import * as React from 'react'

import { BECAUSE, BUT, SO } from '../../../constants/evidence'

export interface ConjunctionSpecificTipRow {
  conjunction: string;
  stem: string;
  response: string | null;
  core_start: number | null;
  core_end: number | null;
  detail_start: number | null;
  detail_end: number | null;
  core_label: string | null;
  core_description: string | null;
  detail_label: string | null;
  detail_description: string | null;
}

export interface ConjunctionSpecificTip {
  id: number;
  name: string;
  rows: ConjunctionSpecificTipRow[];
}

export type ResponseAnnotation = 'core' | 'detail'

export interface ResponseSegment {
  text: string;
  annotation?: ResponseAnnotation;
}

export const CONJUNCTION_PURPOSES = {
  [BECAUSE]: 'to show a cause or reason',
  [BUT]: 'to show a contrast or challenge',
  [SO]: 'to show a result or consequence',
}

// Descriptions mark emphasis with asterisks, as in "Explains *why* she left the path".
export const withEmphasis = (text: string | null) => (text ?? '').split('*').map((part, index) => (
  index % 2 ? <em key={index}>{part}</em> : <React.Fragment key={index}>{part}</React.Fragment>
))

export const conjunctionSpecificTipRow = (tip: ConjunctionSpecificTip | undefined, conjunction: string) => (
  tip?.rows.find(row => row.conjunction === conjunction)
)

export const annotatedResponse = ({ response, core_start, core_end, detail_start, detail_end, }: ConjunctionSpecificTipRow): ResponseSegment[] => {
  const fullResponse = response ?? ''
  const annotations = [{ start: core_start, end: core_end, annotation: 'core' as const }, { start: detail_start, end: detail_end, annotation: 'detail' as const }]
    .filter(span => span.start !== null && span.end !== null && span.start < span.end)
    .sort((a, b) => a.start - b.start)

  const segments: ResponseSegment[] = []
  let position = 0
  annotations.forEach(({ start, end, annotation, }) => {
    if (start < position) { return }
    if (start > position) { segments.push({ text: fullResponse.slice(position, start) }) }
    segments.push({ text: fullResponse.slice(start, end), annotation })
    position = end
  })
  if (position < fullResponse.length) { segments.push({ text: fullResponse.slice(position) }) }

  return segments
}
